
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/combos/[slug]",
      function () {
        return require("private-next-pages/combos/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/combos/[slug]"])
      });
    }
  